import { BUSINESS } from '../lib/business';

export const OfficeAddress = ({ testId = 'office-address' }) => (
  <address className="not-italic leading-relaxed" data-testid={testId}>
    <span className="block font-semibold">{BUSINESS.office}</span>
    <span className="block">{BUSINESS.street}</span>
    <span className="block">{BUSINESS.locality}</span>
  </address>
);
